<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <v-card-title style="height: 60px">账单详情</v-card-title>
      <v-form ref="billForm">
        <v-layout column class="pa-3">
          <v-layout>
            <v-flex xs6>
              <v-text-field
                label="账单状态"
                prepend-icon="$vuetify.icons.code"
                v-model="form.status"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <l-plate-picker
                v-model="form.plateNumb"
                readonly
              ></l-plate-picker>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                label="账单金额"
                prepend-icon="mdi-cash-usd"
                v-model="form.paidAmount"
                suffix="元"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-text-field
                label="进场卡口"
                prepend-icon="$vuetify.icons.location"
                v-model="form.entryPortName"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <l-select-datetime
                label="进场时间"
                v-model="form.entryTime"
                readonly
              ></l-select-datetime>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-text-field
                label="出场卡口"
                prepend-icon="$vuetify.icons.location"
                v-model="form.departurePortName"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <l-select-datetime
                label="出场时间"
                v-model="form.departureTime"
                readonly
              ></l-select-datetime>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-textarea
              rows="1"
              auto-grow
              v-model="form.description"
              label="账单描述"
              prepend-icon="$vuetify.icons.comment"
              readonly
            >
            </v-textarea>
          </v-layout>
          <v-layout justify-center>
            <v-btn
              flat
              color="primary"
              v-if="!(form.status === 'paid')"
              @click="pay()"
              >支付缴费</v-btn
            >
            <v-btn
              flat
              color="primary"
              v-if="!showDetails"
              @click="showDetails = !showDetails"
              >点击查看账单明细</v-btn
            >
            <v-btn
              flat
              color="primary"
              v-if="showDetails"
              @click="showDetails = !showDetails"
              >隐藏账单明细</v-btn
            >
          </v-layout>
          <v-layout v-if="showDetails">
            <v-flex xs12>
              <l-data-table
                :items="form.subBills"
                :headers="header"
                hide-title
              ></l-data-table>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-form>
    </v-card>
    <v-dialog width="350px" v-model="payDialog" persistent>
      <v-layout column justify-center>
        <v-card>
          <v-card-title>
            <h3>请扫码支付</h3>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-layout justify-center>
            <img :src="codeUrl" style="width: 200px; height: 200px" />
          </v-layout>
          <v-layout justify-center>
            <v-btn
              class="primary"
              @click="
                payDialog = false;
                getBillInfo();
              "
              >我已完成扫码支付</v-btn
            >
          </v-layout>
        </v-card>
      </v-layout>
    </v-dialog>
  </l-layout>
</template>

<script>
import { BILL_STATUS_TEXT } from "@/object";
import LPlatePicker from "../../../components/LPlatePicker";
import LSelectDatetime from "../../../ladmin/components/LSelectDatetime/LSelectDatetime";
import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
let chargingTypeMap = {
  simple: "简单计费",
  period: "周期计费",
};
export default {
  name: "billDetail",
  components: { LDataTable, LSelectDatetime, LPlatePicker },
  props: {
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      showDetails: false,
      payDialog: false,
      form: {
        plateNumb: "",
        paidAmount: "",
        entryPortId: "",
        entryPortName: "",
        entryTime: "",
        departurePortId: "",
        departurePortName: "",
        departureTime: "",
        description: "",
        status: "",
        subBills: [],
      },
      codeUrl: "",
      header: [
        {
          text: "驶入卡口",
          value: "entryPortName",
          sortable: false,
          align: "left",
        },
        {
          text: "驶入时间",
          value: "entryTime",
          sortable: false,
          align: "left",
          f: (v) => this.$L.time.stringify(v),
        },
        {
          text: "驶出卡口",
          value: "departurePortName",
          sortable: false,
          align: "left",
        },
        {
          text: "驶出时间",
          value: "departureTime",
          sortable: false,
          align: "left",
          f: (v) => this.$L.time.stringify(v),
        },
        {
          text: "账单金额",
          value: "payableAmount",
          sortable: false,
          align: "left",
        },
      ],
    };
  },
  created() {
    console.log(this.formData);
    this.init();
  },
  methods: {
    async getBillInfo() {
      let { items, amount } = await this.$store.dispatch("pay/getBillList", {
        pagination: { page: 1, rowsPerPage: 10 },
        search: { key: "id", value: this.formData.id },
      });
      // console.log(items)
      this.formData = items[0];
      this.init();
    },
    init() {
      this.form.plateNumb = this.formData.plateNumb;
      this.form.paidAmount = this.formData.paidAmount;
      this.form.entryPortId = this.formData.entryPortId;
      this.form.entryPortName = this.findController(this.formData.entryPortId);
      this.form.entryTime = this.$L.time
        .stringify(this.formData.entryTime)
        .substr(0, 16);
      this.form.departurePortId = this.formData.departurePortId;
      this.form.departurePortName = this.findController(
        this.formData.departurePortId
      );
      this.form.departureTime = this.$L.time.stringify(
        this.formData.departureTime
      );
      this.form.description = this.formData.description;
      this.form.status = BILL_STATUS_TEXT[this.formData.status];
      this.form.subBills = this.formData.subBills.map((item) => ({
        ...item,
        entryPortName: this.findController(item.entryPortId),
        departurePortName: this.findController(item.departurePortId),
      }));
    },
    async getPayCode() {
      let p = await this.$store.dispatch("login/getSelfInfo");
      let params = {
        userId: "",
        billId: this.formData.id,
      };
      try {
        let res = await this.$store.dispatch("pay/getPayCode", params);
        if (res.data.status + "" === "200") {
          this.codeUrl = "/qrcode" + res.data.data;
        }
      } catch (e) {}
    },
    async pay() {
      await this.getPayCode();
      this.payDialog = true;
    },
    findController(id) {
      let controllers = this.$store.state.parkingLot.controllerList;
      for (let i = 0; i < controllers.length; i++) {
        if (controllers[i].id === id) {
          return controllers[i].name;
        }
      }
      return null;
    },
  },
};
</script>

<style scoped>
</style>
